export default "__VITE_ASSET__CoB4mhDV__"